angular.module('tgaAdmin').service('StreamService', ['$log',
  function ($log) {
    const queue = {
      player_answers: [],
      player_sessions: {},
      session_group: {},
    };

    const streams = [
      {
        event: 'instructor:session_player_answer',
        callback: (data) => {
          queue.player_answers.push(...data);
          $log.debug('instructor getLiveSession stream answer', queue);
        },
      },
      {
        event: 'instructor:session_player_session',
        callback: (data) => {
          data?.forEach((session) => {
            if (!session.user_id) return;
            queue.player_sessions[session.session_id] = session;
          });
          $log.debug('instructor getLiveSession stream session', queue);
        },
      },
    ];

    function initialize(data) {
      if (data.player_answers) queue.player_answers = data.player_answers;
      if (data.player_sessions) {
        queue.player_sessions = {};
        data.player_sessions.forEach((session) => {
          if (!session.user_id) return;
          queue.player_sessions[session.session_id] = session;
        });
      }
      if (data.session_group) queue.session_group = data.session_group;
    }

    function getLiveSession() {
      $log.debug('instructor getLiveSession', queue);
      return {
        player_answers: queue.player_answers,
        player_sessions: Object.values(queue.player_sessions),
        session_group: queue.session_group,
      };
    }

    return {
      streams,
      initialize,
      getLiveSession,
    };
  },
]);
